<template>
  <div id="partners-list">
    <transition name="fade" mode="out-in">
      <template v-if="!isLoading && partners.length > 0">
        <base-table
          :minWidth="'fit-content'"
          :body="partners"
          :columns="tableColumns"
        >
          <template slot="coordinates" slot-scope="props">
            {{ JSON.parse(props.item.coordinates).long }},
            {{ JSON.parse(props.item.coordinates).lat }}
          </template>
          <template slot="edit-action" slot-scope="props">
            <div
              class="action-wrapper edit"
              @click.stop="editPartner(props.item)"
            >
              {{ $t("partnerScreen.partnerList.table.headers.edit") }}
            </div>
          </template>
          <template slot="delete-action" slot-scope="props">
            <div
              class="action-wrapper delete"
              @click.stop="removePartner(props.item)"
            >
              {{ $t("partnerScreen.partnerList.table.headers.delete") }}
            </div>
          </template>
        </base-table>
      </template>
    </transition>
  </div>
</template>

<script>
import PartnersModal from "@/components/modules/Partners/PartnersModal";
import DeleteModal from "@/components/shared/Modals/DeleteModal";
import { mapActions } from "vuex";
export default {
  name: "PartnersList",
  props: {
    partners: {
      type: Array
    }
  },
  components: {},
  data: () => ({
    isLoading: true
  }),
  mounted() {
    this.isLoading = false;
  },
  computed: {
    tableColumns() {
      return [
        {
          key: "name",
          name: "partnerScreen.partnerList.table.headers.name"
        },
        {
          key: "partnerID",
          name: "partnerScreen.partnerList.table.headers.partnerID"
        },
        {
          key: "email",
          name: "partnerScreen.partnerList.table.headers.email"
        },
        {
          key: "location",
          name: "partnerScreen.partnerList.table.headers.location"
        },
        {
          key: "edit-action",
          name: "",
          needAction: false,
          sorting: false
        },
        {
          key: "delete-action",
          name: "",
          needAction: false,
          sorting: false
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      deletePartner: "partners/deletePartner"
    }),
    editPartner(item) {
      this.$eventBus.showModal({
        title: this.$t("partnersScreen.partnersModal.update.title"),
        bind: {
          is: PartnersModal,
          width: "500px",
          height: "555px",
          partner: item
        },
        on: {
          refreshData: () => {
            this.$emit("getPartners");
          }
        }
      });
    },
    removePartner(item) {
      this.$eventBus.showModal({
        title: this.$t("partnersScreen.partnersList.deleteModal.title"),
        bind: {
          is: DeleteModal,
          height: "200px",
          text: this.$t("partnersScreen.partnersList.deleteModal.text", {
            name: item.name,
            partnerID: item.partnerID
          })
        },
        on: {
          deleteClicked: () => {
            this.$eventBus.closeModal();
            this.deleteAction(item);
          }
        }
      });
    },
    deleteAction(item) {
      this.deletePartner({ id: item.id })
        .then(res => {
          if (res.status === "OK") {
            this.$notification.showNoti(
              "success",
              "partnersList.delete.success"
            );
            this.$emit("getPartners");
          } else {
            this.$notification.showNoti("error", null, res);
          }
        })
        .catch(() => {
          this.$notification.showNoti("error", "partnersList.delete.error");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#partners-list {
  .empty-state {
    margin-top: 60px;
  }
}
</style>
